module.exports = __webpack_public_path__ + "img/percent.f5708cf6.svg";